import isTouch from 'static/script/utils/is-touch';
import defineComponent from 'flight';

function ScrollToTopUI() {
    this.defaultAttrs({
        linkSelector: '[data-scroll-to-top-link]',
        activeClass: 'active'
    });

    this._scrollToTop = function() {
        window.scrollTo(0, 1);
        this._disableButton();
        this.select('linkSelector').blur();
        this._trackClicks();
    };

    this._toggleElement = function() {
        let scrollY = this.$window.scrollTop();

        // var scrollY = this.$window.scrollTop(),
        //     offset = 4;

        // if (scrollY > 100 && this.lastScrollY > scrollY) {
        //     if ((this.lastScrollY - offset) > scrollY && !this.$node.hasClass(this.attr.activeClass)) {
        //         this.$node.addClass(this.attr.activeClass);
        //     }
        // } else if (scrollY > 100 && (this.lastScrollY + offset) < scrollY && this.$node.hasClass(this.attr.activeClass)) {
        //     this.$node.removeClass(this.attr.activeClass);
        // } else if (scrollY < 100 && this.$node.hasClass(this.attr.activeClass)) {
        //     // If scrollY < 100
        //     console.log('-- Too close. Remove', scrollY);
        //     this.$node.removeClass(this.attr.activeClass);
        // }

        if (scrollY > 100) {
            this._enableButton();
        } else {
            this._disableButton();
        }

        this.lastScrollY = scrollY;
    };

    this._enableButton = function() {
        this.select('linkSelector').attr('disabled', false);
        this.$node.addClass(this.attr.activeClass);
    };

    this._disableButton = function() {
        this.select('linkSelector').attr('disabled', true);
        this.$node.removeClass(this.attr.activeClass);
    };

    this._trackClicks = function() {
        let data = {
            category: 'Item result list',
            action: 'Navigation',
            label: 'Scroll to top'
        };

        this.trigger('analytics:track-event', data);
    };

    this.after('initialize', function() {
        let scrollEvent = 'scroll';

        this.throttledToggleElement = _.throttle(this._toggleElement, 50);

        this.lastScrollY = window.scrollY;
        this.$window = $(window);

        // if (isTouch()) {
        //     scrollEvent = 'scroll';
        // } else {
        //     scrollEvent = 'scroll';
        // }

        // this.on(document, scrollEvent, this.throttledToggleElement);
        this.on(document, scrollEvent, this.throttledToggleElement.bind(this));

        this.on('click', {
            linkSelector: this._scrollToTop
        });
    });
}

export default defineComponent.component(ScrollToTopUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/scroll-to-top-ui.js